import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import mobileLogo from '../../../assets/logo/mobile-logo.png';
import MobileSideBar from './MobileSideBar';

const CustomerHeader = () => {
  const { t } = useTranslation();
  return (
    <>
      {/* Mobile Header */}
      <header className="laptop:hidden fixed top-0 left-0 right-0 px-4 z-30 border-b border-border bg-card/95 backdrop-blur supports-[backdrop-filter]:bg-card/60">
        <div className="flex justify-between items-center my-2.5">
          <div className="flex">
            <Link to="/">
              <img
                src={mobileLogo}
                alt={t('customer_sidebar.logo_alt')}
                className="h-10 cursor-default"
              />
            </Link>
          </div>
          <div className="flex items-center gap-5">
            <MobileSideBar />
          </div>
        </div>
      </header>
    </>
  );
};

export default React.memo(CustomerHeader);
